interface ISingleTitleProps {
  children: React.ReactNode;
  UNSAFE_className?: string;
}

export const SingleTitle: React.FC<ISingleTitleProps> = ({
  children,
  UNSAFE_className = '',
}) => {
  return (
    <span
      className={`${UNSAFE_className} tw-lf-body-bold-sm tw-text-blue-600 desktop:tw-lf-body-bold-md`}
    >
      {children}
    </span>
  );
};
